var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Click to return")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }